import Vue from 'vue'

export const useMenuBar = Vue.observable({
  styles: {}
})
export const useMutationMenuBar = {
  setMenuBarStyles: (styles) => {
    useMenuBar.styles = styles
  }
}